import { toast } from 'react-toastify'
import {
  getAllPoliciesAgreements,
  getAllPolicyById,
  getAllPublishedPolicies,
} from '../../../api/candidate/policies'
import {
  getSinglePolicy,
  policiesAgreement,
  policiesAgreementResponse,
  policyResponseObject,
  policyResponseStaff,
} from '../../../utils/types'

export const getPolicyData = async (): Promise<policyResponseStaff> => {
  const response = (await getAllPublishedPolicies()) as policyResponseStaff

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response
}

export const getPolicyAgreement = async (): Promise<policiesAgreement[]> => {
  const response =
    (await getAllPoliciesAgreements()) as policiesAgreementResponse

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}

export const getPolicyDataById = async (
  id: string
): Promise<getSinglePolicy> => {
  const response = (await getAllPolicyById(id)) as policyResponseObject

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}
